import React from 'react';
import SearchInput from './index';
import Localization from '../../config/localization';
import { useSearch } from '../../hooks/search';
import * as UtilApi from '../../api/util';

const CityHallSearch = React.forwardRef((props: any, ref) => {
  const { selectedData: selectedCityHall, data: cityHalls, onChange, getData } = useSearch({
    ref,
    onChange: props.onChange,
    onUpdate: props.onUpdate,
    api: UtilApi.SearchCityHall,
  });

  return (
    <SearchInput
      getLabel={(place?: Utils.ICityHall) => place ? `${place.crc} ${place.name}` : ''}
      label={Localization.paymentsReportsSelectCityHall}
      placeholder={Localization.reportCityHallPlaceholder}
      {...props}
      defaultOption={selectedCityHall}
      places={cityHalls}
      onUpdate={getData}
      onChange={onChange}
    />
  );
});

export default CityHallSearch;